import React from "react";

function BlogCategoryFilter({ categories, value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2" role="tablist" aria-label="Filter by topic">
      {categories.map((cat) => {
        const selected = value === cat;
        return (
          <button
            key={cat}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(cat)}
            className={`rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors ${
              selected
                ? "border-slate-800 bg-slate-800 text-white"
                : "border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50"
            }`}
          >
            {cat}
          </button>
        );
      })}
    </div>
  );
}

export default BlogCategoryFilter;
